
export interface Keyed { getKey(): string }

export function groupKeys<T extends Keyed> (arr: T[]): string[] {
    return Array.from(new Set(arr.map(k => k.getKey())).values())
}

export function groupKeysBy<T> (arr: T[], fn: ((v: any) => string)): string[] {
    return Array.from(new Set(arr.map(fn).filter(v => !!v)))
}

export function groupItemsByKey<T> (arr: T[], keyFn: ((v: any) => string), fn: ((v: any) => T[])) {
    const groups = new Map<string, T[]>()
    const grouped = arr.reduce((m: Map<string, T[]>, v) => {
        const key = keyFn(v)
        const prev = m.get(key) ?? []
        m.set(key, prev.concat([v]))
        return m
    }, new Map<string, T[]>())

    return grouped.entries()
}

export function countKeysBy<T> (arr: T[], fn: ((v: any) => string)): Map<string, number> {
    return arr.reduce((o: Map<string, number>, v) => {
        const k = fn(v)
        o.set(k, (o.get(k) ?? 0) + 1)
        return o
    }, new Map<string, number>())
}

// https://github.com/microsoft/TypeScript/issues/20707#issuecomment-352115044
export function notUndefined<T>(x: T | undefined): x is T { return x !== undefined }

/***
 * Returns identitier containing only lowercase letters and digits, used in instanceIds
 * @param s Input string
 */
export const safeIdentifier = (s?: string) => s?.toLowerCase()?.replace(/[^a-z0-9]/g, '')
